import type { RouteInfoRouteType, RouteInfoTollsType } from '../../AssignmentApi';
import type { RouteCostType } from '../../../Settings/settings';
import { get } from 'svelte/store';
import { customerSettings } from '../../../../../stores/api';
import type { VehicleResponseType } from '../../../Vehicles/types';

export class RouteInfoUtils {
    // private static routeCostPerItem: number = 0; // -- ustalone z Rafałem telefonicznie 2024.08.22
    // private static routeCostPerKm: number = 0.8; // -- ustalone z Rafałem telefonicznie 2024.08.22
    // private static routeCostPerMin: number = 0.6; // -- ustalone z Rafałem telefonicznie 2024.08.22
    // private static routeCostUnit: string = 'zł';

    static getQuantity(routeInfo: RouteInfoRouteType) {
        /*
        points: Array(22) [ {…}, {…}, {…}, … ]
0: Object { id: 381275, jobs: null, delta: null, … }
1: Object { id: 381276, jobs: (1) [123], delta: {…}, … }
2: Object { id: 381291, jobs: (1) [333,444], delta: {…}, … }
3: Object { id: 381296, jobs: (1) [555,666], delta: {…}, … }
4: Object { id: 381295, jobs: (1) null, delta: {…}, … }
5: Object { id: 381293, jobs: (1) [123], delta: {…}, … }
         */
        let jobs: number[] = [];
        if (routeInfo !== null && routeInfo.points) {
            routeInfo.points.forEach((point: any) => {
                if (point.jobs) {
                    jobs.push(...point.jobs);
                }
            });
        }
        let uniqueJobs = new Set(jobs);
        return uniqueJobs.size;
    }

    // static getCost(routeInfo: any) {
    //     let quantity = RouteInfoUtils.getQuantity(routeInfo);
    //     let distance_m = routeInfo.distance_m;
    //     let cost =
    //         quantity * RouteInfoUtils.routeCostPerItem +
    //         (distance_m / 1000) * RouteInfoUtils.routeCostPerKm;
    //     return cost;
    // }

    static getCostByDistanceAndQuantity(
        distance_m: number | null,
        quantity: number | null,
        duration_s: number | null,
        tolls: RouteInfoTollsType | null = null,
        vehicle: VehicleResponseType | null = null,
        costDetails: Record<string,(number|null)[]>|null = null
    ): number | null {
        let globalRouteCost: RouteCostType | null = get(customerSettings).route_cost ?? null;
        let routeCost: RouteCostType | null = globalRouteCost ? { ...globalRouteCost } : null;
        if (vehicle?.route_cost) {
            for (let i in vehicle.route_cost) {
                if (typeof vehicle.route_cost[i] == 'number') {
                    routeCost[i] = vehicle.route_cost[i];
                }
            }
        }
        if (distance_m === null || quantity === null || quantity < 0 || duration_s === null) {
            return null;
        }
        if (routeCost === null) {
            throw new Error('routeCost is null in getCostByDistanceAndQuantity');
        }
        if (duration_s < 0) {
            duration_s = 0;
        }
        if (distance_m < 0) {
            distance_m = 0;
        }
        let cost: number =
            routeCost.per_init +
            quantity * routeCost.per_item +
            (distance_m / 1000) * routeCost.per_km +
            (duration_s / 60) * routeCost.per_min;
        // console.log('getCostByDistanceAndQuantity, cost', cost, {
        //     distance_m,
        //     quantity,
        //     duration_s,
        //     routeCost,
        // });
        if (costDetails !== null) {
            costDetails.init = [null, routeCost.per_init],
            costDetails.distance = [distance_m, (distance_m / 1000) * routeCost.per_km];
            costDetails.duration = [duration_s, (duration_s / 60) * routeCost.per_min];
            costDetails.job = [quantity, quantity * routeCost.per_item];
        }
        if (tolls && globalRouteCost.tolls) {
            cost += tolls.etoll?.price.brutto ?? 0;
            cost += tolls.highways?.price.brutto ?? 0;
            if (costDetails !== null) {
                if (tolls.etoll) {
                    costDetails.tolls_etoll = [tolls.etoll.distance?.total ?? null, tolls.etoll.price.brutto]
                }
                if (tolls.highways) {
                    costDetails.tolls_highways = [tolls.highways.distance?.total ?? null, tolls.highways.price.brutto]
                }
            }
        }
        return cost;
    }

    static getCurrency(): string {
        let routeCost: RouteCostType | null = get(customerSettings).route_cost ?? null;
        if (routeCost === null) {
            throw new Error('routeCost is null in getCurrency');
        }
        return routeCost.unit;
    }
}
